export default {

    apiUrl: 'https://aveco-loggerdatabase.wittigdemo.nl/api',
    munisenseApiUrl: 'https://avecodebondt.water-munisense.net/webservices/v2',
    loginUrl: 'https://mijn-aveco.wittigdemo.nl/login?app=loggers',
    mijnAvecoUrl: 'https://mijn-aveco.wittigdemo.nl/',

    apps: [
        { id: 'mijn-aveco', name: 'Mijn Aveco de Bondt', url: 'https://mijn-aveco.wittigdemo.nl' },
        { id: 'monitor', name: 'Monitoringsplatform', url: 'https://aveco-monitor.wittigdemo.nl' },
        { id: 'veldwerkwinkel', name: 'Veldwerkwinkel', url: 'https://aveco-veldwerkwinkel.wittigdemo.nl' },
        { id: 'loggers', name: 'Loggerdatabase', url: 'https://aveco-loggerdatabase.wittigdemo.nl' },
        { id: 'veldwerkdata', name: 'Veldwerkdata', url: 'https://aveco-veldwerkdata.wittigdemo.nl' }
    ]
}
